export enum CredentialBasicTypeEnum {
  KEYCARD = 'KEYCARD',
  MOBILE_KEY = 'MOBILE_KEY',
  QR = 'QR',
  OTHER = 'OTHER',
}
